import React from 'react';
import DashboardStats from '../components/DashboardStats';
import DashboardRecentActivity from '../components/DashboardRecentActivity';
import DashboardGallery from '../components/DashboardGallery';

const DashboardPage = () => {
  return (
    <>
      <DashboardStats />
      <DashboardRecentActivity />
      <DashboardGallery />
    </>
  );
};

export default DashboardPage;